import script from "./PageThreadPosts.vue?vue&type=script&setup=true&lang=js"
export * from "./PageThreadPosts.vue?vue&type=script&setup=true&lang=js"

import "./PageThreadPosts.vue?vue&type=style&index=0&id=7da407f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da407f7"]])

export default __exports__